<template>
  <div>
  <b-card border-variant="dark">
    <div class="height-user">
      <h5>Operadores</h5>

      <div class="select-queue">
        <select class="form-control form-control-sm queue-select" v-model="changeQueue">
          <option value="*" selected>Todas as Filas</option>
          <option v-for="(queue, index) in userChatQueues" :key="index" :value="queue">
            {{queue}}
          </option>
        </select>
      </div>

      <b-table class="customTable" small striped bordered fixed sticky-header="782px" :fields="fields" :items="items" responsive="sm">
        <!-- A custom formatted column -->
        <template #cell(status)="data">
          <div>
            <b-badge :variant="getStatus(data.item.status).variant">{{ getStatus(data.item.status).txt }}</b-badge>
          </div>
        </template>

        <!-- opcoes -->
        <template #cell(opcoes)="data">
          <i title="Visualizar conversa" id="action-button-view" class="image-button fa fa-eye" @click.prevent="abrirModalUsers(data.item.opcoes)"></i>
        </template>

      </b-table>
      <h6 class="mb-2">Total de {{ items.length }} registros</h6>
    </div>
  </b-card>

  <dtModalUsers ref="dtModalUsers"/>

</div>
</template>

<script>
import { mapMutations } from 'vuex';

const socket = require('./../../../modules/realtime/service/service');

export default {
  name: "TbUsers",
data:() => ({
    fields: [
      {key: 'user', label: 'Operador', class: 'text-center align-middle', thStyle: {'font-weight': 'bold'}},
      {key: 'login', label: 'Login', class: 'w-log text-center allign-middle', thStyle: {'font-weight': 'bold'}},
      {key: 'status', label: 'Status', class: 'middle w-stt text-center allign-middle', thStyle: {'font-weight': 'bold'}},
      {key: 'opcoes', label: 'Ações', class: 'middle w-stt text-center allign-middle', thStyle: {'font-weight': 'bold'}}
    ],
    users: [],
    operatorAvailable: { disponivel: {} },
    operatorInAttendance: [],
    userChatQueues: [],
    changeQueue: "*",
    queueSelect: "*",
    items: [],

    _realtimeJoined: false,
    _onAttendanceBound: null,
    _onAvailableBound: null,
    _onReconnectBound: null
  }),

  mounted() {
    axios.get('/realtime/listUsers').then(({data}) => {
      this.users = data || [];
      this.items = this.getOperators(this.queueSelect);
    });

    axios.get('/user-chat-queues').then(({data}) => {
      this.userChatQueues = data || [];
    });

    this.joinRealtime();
  },

  beforeDestroy() { this.leaveRealtime(); },
  deactivated()   { this.leaveRealtime(); },
  activated()     { this.joinRealtime(); },

  methods: {
    ...mapMutations(['setLogChat','setLogInfo']),

    joinRealtime() {
      if (this._realtimeJoined) return;

      socket.connection.emit('realtime:join');

      this._onAttendanceBound = (obj) => {
        const lista = (obj && Array.isArray(obj.atendimento)) ? obj.atendimento : [];
        this.operatorInAttendance = lista.filter((thing, index, self) =>
          index === self.findIndex((t) => (t && thing && t.operator === thing.operator))
        );
        this.items = this.getOperators(this.queueSelect);
      };
      socket.connection.on('attendanceChat', this._onAttendanceBound);

      this._onAvailableBound = (obj) => {
        if (obj && obj.disponivel && typeof obj.disponivel === 'object') {
          this.operatorAvailable = { disponivel: obj.disponivel };
        } else {
          this.operatorAvailable = { disponivel: {} };
        }
        this.items = this.getOperators(this.queueSelect);
      };
      socket.connection.on('availableChat', this._onAvailableBound);

      this._onReconnectBound = () => {
        if (this._realtimeJoined) socket.connection.emit('realtime:join');
      };
      socket.connection.on('connect', this._onReconnectBound);

      this._realtimeJoined = true;
    },

    leaveRealtime() {
      if (!this._realtimeJoined) return;

      socket.connection.emit('realtime:leave');

      if (this._onAttendanceBound) {
        if (socket.connection.off) socket.connection.off('attendanceChat', this._onAttendanceBound);
        else socket.connection.removeListener('attendanceChat', this._onAttendanceBound);
        this._onAttendanceBound = null;
      }
      if (this._onAvailableBound) {
        if (socket.connection.off) socket.connection.off('availableChat', this._onAvailableBound);
        else socket.connection.removeListener('availableChat', this._onAvailableBound);
        this._onAvailableBound = null;
      }
      if (this._onReconnectBound) {
        if (socket.connection.off) socket.connection.off('connect', this._onReconnectBound);
        else socket.connection.removeListener('connect', this._onReconnectBound);
        this._onReconnectBound = null;
      }

      this._realtimeJoined = false;
    },

    getStatus(stt) {
      if (stt === 'c_deslogado')     return { txt: 'Deslogado',      variant: 'danger'  };
      if (stt === 'a_em_atendimento') return { txt: 'Em Atendimento', variant: 'warning' };
      if (stt === 'b_ativo')          return { txt: 'Disponível',     variant: 'primary' };
      return { txt: stt, variant: 'secondary' };
    },

    abrirModalUsers(idUsers){
      this.setLogInfo(idUsers);
      this.$refs.dtModalUsers.openModal();
    },

    getOperators(queueSelect) {
      const doubles = [];
      this.users.forEach(us => {
        const filas = us.queueChat || [];
        const incluiFila = (queueSelect === '*') || filas.includes(queueSelect);
        if (incluiFila) {
          doubles.push({
            user: us.nome,
            fila: filas,
            rede_social: 'WhatsApp',
            ramal: (us.extension_line || '').toString(),
            login: '00:00:00',
            status: filas.map(() => 'c_deslogado')
          });
        }
      });

      const disponivel = (this.operatorAvailable && this.operatorAvailable.disponivel) ? this.operatorAvailable.disponivel : {};

      const data = doubles.map((us) => {
        const isAvailable = !!disponivel[us.ramal];
        let op = null;
        for (const el of (this.operatorInAttendance || [])) {
          if (el && el.operator === us.ramal) { op = el; break; }
        }

        if (isAvailable && op) {
          const notSortFila = [];
          const statusFila = us.fila.map((el) => {
            if (op.operator === us.ramal && el === op.queue) {
              notSortFila.push('a_em_atendimento');
              return 'a_em_atendimento';
            } else {
              notSortFila.push('b_ativo');
              return 'b_ativo';
            }
          });
          statusFila.sort(); 

          return {
            user: us.user,
            rede_social: 'WhatsApp',
            login: disponivel[us.ramal].login ? moment(disponivel[us.ramal].login).format('HH:mm:ss') : '00:00:00',
            status: statusFila[0],
            opcoes: { ramal: us.ramal, fila: notSortFila },
            queueChat: us.fila
          };
        }

        if (isAvailable) {
          return {
            user: us.user,
            rede_social: 'WhatsApp',
            login: disponivel[us.ramal].login ? moment(disponivel[us.ramal].login).format('HH:mm:ss') : '00:00:00',
            status: 'b_ativo',
            opcoes: { ramal: us.ramal, fila: us.status ? us.status.map(() => 'b_ativo') : us.fila.map(() => 'b_ativo') },
            queueChat: us.fila
          };
        }

        return {
          user: us.user,
          rede_social: 'WhatsApp',
          login: '00:00:00',
          status: 'c_deslogado',
          opcoes: { ramal: us.ramal, fila: us.status ? us.status.map(() => 'c_deslogado') : us.fila.map(() => 'c_deslogado') },
          queueChat: us.fila
        };
      });

      this.setLogChat(data);
      return data;
    }
  },

  watch: {
    operatorAvailable() {
      this.items = this.getOperators(this.queueSelect);
    },
    operatorInAttendance() {
      this.items = this.getOperators(this.queueSelect);
    },
    changeQueue(queue) {
      this.queueSelect = queue;
      this.items = this.getOperators(queue);
    }
  }
};
</script>


<style>
  .height-user {
    max-height: 890px;
  }
  .card {
    color: black !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.25rem !important;
  }
  td.fila, td.middle {
    padding: 0;
  }
  .customTable>table>tbody>tr>td:nth-child(4)>div, .customTable>table>tbody>tr>td:nth-child(5)>div {
    /*display: flex;*/
    padding: 0.25rem 0 0.25rem 0.3rem;
  }
  .customTable>table>tbody>tr>td:nth-child(4)>div:not(:last-child), .customTable>table>tbody>tr>td:nth-child(5)>div:not(:last-child) {
    border-bottom: 1px solid #dee2e6;
  }
  .customTable>table>tbody>tr>td:nth-child(5)>div {
    height: 32px;
  }
  th.w-log {
    width: 90px;
  }
  th.w-social {
    width: 106px;
  }
  th.w-stt {
    width: 110px;
  }

  .select-queue{
    display: inline-block;
    width: 100%;
  }
  .select-queue select{
    width: 30%;
    float: right;
  }
  #action-button-view {
    cursor: pointer;
    font-size: 16px;
    color: #1c869a;
    transition: 0.25s;
    margin: 5px;
  }

  #action-button-view:hover {
    color: #177081;
  }
</style>